/* tslint:disable */
/* eslint-disable */
/**
 * Shopping Cart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CartBorrowerInfosDtoPricing
 */
export interface CartBorrowerInfosDtoPricing {
    /**
     * 
     * @type {number}
     * @memberof CartBorrowerInfosDtoPricing
     */
    totalPriceEightYears?: number;
    /**
     * 
     * @type {number}
     * @memberof CartBorrowerInfosDtoPricing
     */
    monthPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof CartBorrowerInfosDtoPricing
     */
    averageRate?: number;
}

/**
 * Check if a given object implements the CartBorrowerInfosDtoPricing interface.
 */
export function instanceOfCartBorrowerInfosDtoPricing(value: object): value is CartBorrowerInfosDtoPricing {
    return true;
}

export function CartBorrowerInfosDtoPricingFromJSON(json: any): CartBorrowerInfosDtoPricing {
    return CartBorrowerInfosDtoPricingFromJSONTyped(json, false);
}

export function CartBorrowerInfosDtoPricingFromJSONTyped(json: any, ignoreDiscriminator: boolean): CartBorrowerInfosDtoPricing {
    if (json == null) {
        return json;
    }
    return {
        
        'totalPriceEightYears': json['totalPriceEightYears'] == null ? undefined : json['totalPriceEightYears'],
        'monthPrice': json['monthPrice'] == null ? undefined : json['monthPrice'],
        'averageRate': json['averageRate'] == null ? undefined : json['averageRate'],
    };
}

export function CartBorrowerInfosDtoPricingToJSON(json: any): CartBorrowerInfosDtoPricing {
    return CartBorrowerInfosDtoPricingToJSONTyped(json, false);
}

export function CartBorrowerInfosDtoPricingToJSONTyped(value?: CartBorrowerInfosDtoPricing | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPriceEightYears': value['totalPriceEightYears'],
        'monthPrice': value['monthPrice'],
        'averageRate': value['averageRate'],
    };
}

